module.exports = __webpack_public_path__ + "static/gingerbeer-0d6f8f600f5a430b4b9cabea5c2fe51f.jpg";